import axios from 'axios';

const sendContactForm = ({ email, text }) =>
  axios.post('/sessions/contact-us', { email, text });

export default {
  sendContactForm,
};
